import React, { useState } from 'react';
import Card from '../components/Card';
import Button from '../components/Button';
import Modal from '../components/Modal';

export default function ApiKeys() {
  const [showCreateModal, setShowCreateModal] = useState(false);
  const [showKeyModal, setShowKeyModal] = useState(false);
  const [newKeyName, setNewKeyName] = useState('');
  const [generatedKey, setGeneratedKey] = useState('');
  const [copied, setCopied] = useState(false);

  const existingKeys = [
    { name: 'Production', key: 'sk_live_xxxx...xxxx', created: 'Dec 7', lastUsed: 'Today' },
    { name: 'Testing', key: 'sk_test_xxxx...xxxx', created: 'Dec 1', lastUsed: 'Dec 6' },
  ];

  const handleGenerateKey = () => {
    // Generate a mock API key
    const mockKey = 'sk_live_' + Math.random().toString(36).substr(2, 24);
    setGeneratedKey(mockKey);
    setShowCreateModal(false);
    setShowKeyModal(true);
    setNewKeyName('');
  };

  const handleCopyKey = () => {
    navigator.clipboard.writeText(generatedKey);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <div>
      <div className="page-header">
        <h1 className="page-title">API Keys</h1>
        <p className="page-subtitle">Manage your API authentication keys</p>
      </div>

      <Card 
        title="Your API Keys" 
        subtitle="Use these keys to authenticate API requests"
        actions={
          <Button onClick={() => setShowCreateModal(true)}>
            + Generate New Key
          </Button>
        }
      >
        <div className="table-container" style={{ marginTop: '20px' }}>
          <table className="table">
            <thead>
              <tr>
                <th>Name</th>
                <th>Key</th>
                <th>Created</th>
                <th>Last Used</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {existingKeys.map((key, index) => (
                <tr key={index}>
                  <td style={{ fontWeight: '600' }}>{key.name}</td>
                  <td>
                    <code style={{ color: 'var(--blue)' }}>{key.key}</code>
                  </td>
                  <td>{key.created}</td>
                  <td>{key.lastUsed}</td>
                  <td>
                    <div style={{ display: 'flex', gap: '8px' }}>
                      <button className="btn btn-secondary" style={{ padding: '6px 12px', fontSize: '12px' }}>
                        Copy
                      </button>
                      <button className="btn btn-danger" style={{ padding: '6px 12px', fontSize: '12px' }}>
                        Revoke
                      </button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </Card>

      <div style={{ marginTop: '24px' }}>
        <Card title="API Documentation">
          <div style={{ padding: '20px 0' }}>
            <p style={{ marginBottom: '16px', color: 'var(--text-secondary)' }}>
              Learn how to integrate the Digital Postage API into your system.
            </p>
            <Button variant="secondary">View Documentation</Button>
          </div>
        </Card>
      </div>

      {/* Create Key Modal */}
      <Modal
        show={showCreateModal}
        title="Create New API Key"
        subtitle="Enter a name to identify this key"
        onClose={() => setShowCreateModal(false)}
      >
        <div className="form-group">
          <label className="form-label">Key Name</label>
          <input
            type="text"
            className="form-input"
            placeholder="e.g., Production, Testing, Staging"
            value={newKeyName}
            onChange={(e) => setNewKeyName(e.target.value)}
          />
        </div>

        <div className="form-group">
          <label className="form-label">Permissions</label>
          <div style={{ display: 'flex', flexDirection: 'column', gap: '8px', marginTop: '8px' }}>
            <label style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
              <input type="checkbox" defaultChecked />
              <span style={{ fontSize: '14px' }}>Generate Stamps</span>
            </label>
            <label style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
              <input type="checkbox" defaultChecked />
              <span style={{ fontSize: '14px' }}>Verify Stamps</span>
            </label>
            <label style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
              <input type="checkbox" defaultChecked />
              <span style={{ fontSize: '14px' }}>View Usage</span>
            </label>
            <label style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
              <input type="checkbox" />
              <span style={{ fontSize: '14px' }}>Manage Keys</span>
            </label>
          </div>
        </div>

        <div className="modal-actions">
          <Button variant="secondary" onClick={() => setShowCreateModal(false)}>
            Cancel
          </Button>
          <Button onClick={handleGenerateKey} disabled={!newKeyName}>
            Generate Key
          </Button>
        </div>
      </Modal>

      {/* Show Generated Key Modal */}
      <Modal
        show={showKeyModal}
        title="⚠️ Save Your API Key"
        subtitle="This key will never be shown again. Copy it now and store securely."
        onClose={() => setShowKeyModal(false)}
      >
        <div style={{ 
          padding: '16px', 
          background: 'var(--bg-tertiary)', 
          borderRadius: '8px',
          marginBottom: '20px'
        }}>
          <code style={{ 
            color: 'var(--blue)', 
            fontSize: '14px',
            wordBreak: 'break-all'
          }}>
            {generatedKey}
          </code>
        </div>

        <div className="modal-actions">
          <Button variant="secondary" onClick={() => setShowKeyModal(false)}>
            Close
          </Button>
          <Button onClick={handleCopyKey}>
            {copied ? '✓ Copied!' : 'Copy to Clipboard'}
          </Button>
        </div>
      </Modal>
    </div>
  );
}
